// @flow

import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { ACCESS_TOKEN } from "utils/http";

type Props = {
  component: Function,
  authorized: boolean
};

type StateProps = {
  authorized: boolean,
  lang: string
};

const accessToken = localStorage.getItem(ACCESS_TOKEN)
const PrivateRoute = ({ component: Child, authorized, lang, ...rest }: Props) => (
  <Route
    {...rest}
    render={props => (authorized || accessToken
      ? <Child {...props} />
      : <Redirect to={`/${lang}/`} />
    )}
  />
);

const mapStateToProps = (state): StateProps => ({
  authorized: state.user.authorized,
  lang:       state.user.lang.toLowerCase()
});

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/routes/PrivateRoute.js